import $ from 'jquery';
import { uploadUri } from '../appConfig';

const generateFacilityBlock = (data) => {
	const template = $('._template-block > .facility-section').clone();

	template.find('._link-flag').attr('id', data.id);
	template.find('.title').text(data.title);
	template.find('.description').html(data.brief);

	if (data.opentime) {
		template.find('.opentime').append(`${data.opentime}`);
		template.find('.opentime').removeClass('-hide');
	}

	if (data.fee) {
		template.find('.fee').append(`${data.fee}`);
		template.find('.fee').removeClass('-hide');
	}

	if (data.location) {
		template.find('.location').append(`${data.location}`);
		template.find('.location').removeClass('-hide');
	}

	if (data.note) {
		template.find('.note').text(`※ ${data.note}`);
		template.find('.note').removeClass('-hide');
	}

	let swiperHtml = '';
	$.each(data.images, (i, src) => {
		swiperHtml += `<div class='swiper-slide' style='background-image: url(${uploadUri}/${src})'></div>`;
	});
	template.find('.swiper-wrapper').html(swiperHtml);

	return template.prop('outerHTML');
};

export default generateFacilityBlock;



// WEBPACK FOOTER //
// ./src/js/facilities/generateFacilityBlock.js